<template>
  <Catalogs
    title="Статусы проекта"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'ProjectStatusAdd'"
    :route-edit="'ProjectStatusEdit'"
    :route-view="'ProjectStatusView'"
    :route-path="'/project_statuses'"
    :can-edit="canEditProjectStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "ProjectStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getProjectStatuses(data);
    },
    canEditProjectStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_PROJECT_STATUS_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/ProjectStatuses/ProjectStatuses.vue